var React = require('react');

function Accept (props) {
    return React.createElement("svg",props,React.createElement("polyline",{"className":"fill-none stroke-foreground","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","points":"3.1,13.1 8.1,18 20,6.7 "}));
}

Accept.defaultProps = {"version":"1.0","width":"24px","height":"24px","viewBox":"0 0 24 24","enableBackground":"new 0 0 24 24","xmlSpace":"preserve"};

module.exports = Accept;

Accept.default = Accept;
